import { render, staticRenderFns } from "./TopicDistribution.vue?vue&type=template&id=3ebbfe44&scoped=true"
import script from "./TopicDistribution.vue?vue&type=script&lang=js"
export * from "./TopicDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebbfe44",
  null
  
)

export default component.exports